module.exports = __webpack_public_path__ + "img/IconE.148a09f9.svg";